import React from "react";
import Layout from "../../components/Layout";
import TrainingBanner from "./TrainingBanner";
import TrainingIntro from "./TrainingIntro";
import TrainingCategories from "./TrainingCategories";
import ProgramList from "./ProgramList";
import TrainingFAQ from "./TrainingFAQ";
import ContactSection4 from "../contact/ContactSection4";
import {
  TRAINING_FAQS,
  TRAINING_FEATURED_COURSES,
  TRAINING_SCHEDULED_PROGRAMS,
} from "../../data/trainingData";

const SITE_URL = "https://mbasolutions.co";

const TRAINING_SEO = {
  title:
    "Training Courses | ISO Lead Auditor, Highfield, HACCP, IOSH & Safety | MBA Solutions",
  description:
    "Explore MBA Solutions training courses including ISO Lead Auditor, Highfield (HABC), HACCP, IOSH Managing Safely, PECB, corporate, and workplace safety programs. Public, in-house, and online delivery across Pakistan.",
  keywords:
    "ISO Lead Auditor training, Highfield HABC courses, HACCP training, IOSH Managing Safely, safety training courses, PECB training, corporate training Pakistan, MBA Solutions training",
  canonical: `${SITE_URL}/training`,
};

const buildTrainingJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: "Professional Training Programs | MBA Solutions",
    description: TRAINING_SEO.description,
    url: TRAINING_SEO.canonical,
    isPartOf: {
      "@type": "WebSite",
      name: "MBA Solutions",
      url: SITE_URL,
    },
    about: "Professional compliance, safety, and management system training",
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: SITE_URL,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Training",
        item: TRAINING_SEO.canonical,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "MBA Solutions Featured Training Courses",
    numberOfItems: TRAINING_FEATURED_COURSES.length,
    itemListElement: TRAINING_FEATURED_COURSES.map((course, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: course.title,
      url: `${SITE_URL}${course.link}`,
      description: course.description,
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "Upcoming Public Training Programs",
    itemListElement: TRAINING_SCHEDULED_PROGRAMS.map((program, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: program.title,
      url: `${SITE_URL}${program.link}`,
      item: {
        "@type": "Course",
        name: program.title,
        description: `${program.title} — ${program.category} training with MBA Solutions`,
        provider: {
          "@type": "Organization",
          name: "MBA Solutions",
          url: SITE_URL,
        },
        url: `${SITE_URL}${program.link}`,
      },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: TRAINING_FAQS.map((faq) => ({
      "@type": "Question",
      name: faq.q,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.a,
      },
    })),
  },
];

const Trainings = () => {
  return (
    <Layout
      title={TRAINING_SEO.title}
      description={TRAINING_SEO.description}
      keywords={TRAINING_SEO.keywords}
      canonical={TRAINING_SEO.canonical}
      jsonLd={buildTrainingJsonLd()}
    >
      <div className="training-page bg-white">
        <TrainingBanner />
        <TrainingIntro />
        <TrainingCategories />
        <div id="featured-courses">
          <ProgramList />
        </div>
        <TrainingFAQ />
        <section
          className="bg-gray-50 pt-10 md:pt-14"
          aria-label="Contact for training courses"
          id="training-contact"
        >
          <div className="max-w-3xl mx-auto px-4 text-center mb-2">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Contact for Training Courses
            </h2>
            <div
              className="w-20 h-1 bg-[#F86624] mx-auto rounded-full mb-4"
              aria-hidden="true"
            />
            <p className="text-gray-600">
              Tell us which program you need — our team will help with
              schedules, delivery options, and group bookings.
            </p>
          </div>
          <ContactSection4 />
        </section>
      </div>
    </Layout>
  );
};

export default Trainings;
